import { agencyLocalDay } from '@homecare/domain';

import { systemClock, type Clock } from './clock';
import { useSession } from './session';

/**
 * Today, as the agency's calendar has it (R-1e).
 *
 * Not the browser's zone and never a UTC slice: a scheduler in Denver working
 * for a New York agency books New York's days, and from 7pm Eastern the UTC
 * day is already tomorrow. The zone comes from `/v1/auth/me`. Before the
 * session has loaded there is no agency and therefore no day — callers render
 * nothing date-shaped until it arrives, rather than a guess.
 */
export function useAgencyToday(clock: Clock = systemClock): string | null {
  const timeZone = useSession((state) => state.timeZone);
  return timeZone ? agencyLocalDay(clock.now(), timeZone) : null;
}
